import en from './en';

export const courseTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
